import * as React from "react";
const SvgQuickreply = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v20l4-4h9v-8h7z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 16h-2.2l1.7-4h-5v6h2v5z",
  fill: "currentColor"
}));
export default SvgQuickreply;